const normalizeRoutePath = (path: string) => path.toLowerCase().replace(/\/+$/, '') // Remove trailing slashes and lowercase

export const newPathIsDifferent = (current: string, next?: string) => {
  if (next) {
    if (normalizeRoutePath(next) !== normalizeRoutePath(current)) {
      return true // Path is defined and is different than current, so we redirect
    }
    return false // Path is same
  }

  return false // Path is undefined
}
